var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurbujaDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 682,
    height: 741,
    viewBox: "0 0 682 741",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m659.99 461.79c14.224-37.545 22.01-78.257 22.01-120.79 0-188.33-152.67-341-341-341s-341 152.67-341 341 152.67 341 341 341c23.107 0 45.676-2.298 67.493-6.679-0.29 17.611-9.734 44.02-14.493 55.179-4.4 12 7.833 10.333 14.5 8 171.6-68.4 240.17-215.17 253-280-0.502 1.102-1.006 2.198-1.51 3.287zm-113.8 151.6c-3.181 2.399-6.405 4.745-9.671 7.035 3.203-2.224 6.428-4.566 9.671-7.035z",
    clipRule: "evenodd",
    fill: "#7DB8F2",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m290.47 593.59c-0.90066-3.044-2.9362-8.5872-5.2584-14.321-1.4341-3.5405-1.7655-4.3259-3.8207-9.0557-3.8469-8.8529-4.9782-11.32-7.2723-15.86-3.6503-7.2236-6.6801-12.152-10.02-16.3-1.1928-1.4813-4.4589-4.7768-5.74-5.7917-2.6163-2.0727-5.0869-3.528-7.709-4.5409-0.55157-0.21307-1.0031-0.41444-1.0034-0.44755 0-0.10936 3.5513-3.5418 4.8457-4.682 5.8251-5.1315 11.152-8.2176 16.395-9.4975 1.62-0.39546 2.7789-0.53368 4.5064-0.53745 1.2892 0 1.6326 0.0298 2.2826 0.21722 4.936 1.4229 9.8238 6.7255 15.361 16.665 2.1496 3.8582 3.8154 7.3029 7.3734 15.246 1.4125 3.1534 1.8784 4.1061 1.9632 4.0139 0.0612-0.0667 0.78557-1.2224 1.61-2.5685 14.595-23.832 33.152-46.977 56.044-69.903 19.544-19.573 38.46-35.084 57.663-47.285 3.2834-2.0862 9.988-6.051 10.142-5.9975 0.0635 0.022 4.2258 5.8285 4.5203 6.3059 0.0416 0.0667-0.53141 0.56192-1.4722 1.2717-5.2718 3.9775-11.492 9.2846-17.936 15.303-2.087 1.9491-11.402 11.264-13.617 13.617-9.4375 10.025-18.149 20.117-27.846 32.256-22.994 28.788-40.711 55.743-53.062 80.731l-1.5309 3.0972-4.6672 3.1096c-10.322 6.877-17.378 12.018-21.32 15.532-0.20514 0.18286-0.20522 0.1827-0.43052-0.57871z",
    fill: "#CF7831",
    strokeWidth: 0.097899
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200.99,
    cy: 348.56,
    r: 0.64041,
    fill: "#5df99c",
    stroke: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurbujaDone);
export default __webpack_public_path__ + "static/media/burbuja-done.4bacce601665ac0e2376abdd12727ea1.svg";
export { ForwardRef as ReactComponent };